<template>
    <q-layout view="lHh lpR fFf" style="background-color: #F3F3F7;">

        <q-dialog class="rounded-borders" v-model="dialogDocumentos">
            <q-card style="width: 800px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Documentos</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>

                <q-card-section>
                    <q-scroll-area style="height: 600px;">
                        <Documentos></Documentos>
                    </q-scroll-area>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog persistent class="rounded-borders" v-model="dialogDatosFiscales">
            <q-card style="width: 500px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <q-space />
                    <q-btn icon="close" flat round dense @click="obtenerPerfil()" />
                </q-card-section>

                <q-card-section>
                    <DatosFiscales></DatosFiscales>
                    <div class="row doc-note">
                        <div class="doc-note__title full-width">Notas</div>
                        <p class="">Para poder utilizar el sistema, será necesario registrar previamente los datos
                            fiscales correspondientes a la persona moral o física.</p>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>


        <q-drawer v-model="drawer" show-if-above :mini="!drawer || miniState" @click.capture="drawerClick" :width="250"
            :breakpoint="500" content-class="bg-white">
            <q-scroll-area class="fit" :horizontal-thumb-style="{ opacity: 0 }">
                <q-list :class="[{ 'q-pa-md': !miniState }, { 'rounded-borders': !miniState }, 'text-primary']">

                    <div class=" text-center" :class="{ 'mini-logo-container': miniState }">
                        <router-link to="/dashboard/user/inicio">
                            <img v-if="!miniState" src="../../assets/logo_top.png"
                                :alt="miniState ? 'Logo Mini' : 'Logo Completo'"
                                :style="miniState ? 'width: 48px; height: 48px;  cursor:pointer;' : 'width: 150px; height: auto; cursor:pointer;'"
                                fit="contain" class="logo-image" />
                            <img v-else src="../../assets/logo_top_mini.png"
                                :alt="miniState ? 'Logo Mini' : 'Logo Completo'"
                                :style="miniState ? 'width: 40px; height: 40px; cursor:pointer;' : 'width: 150px; height: auto; cursor:pointer;'"
                                fit="contain" class="logo-image" />
                        </router-link>
                    </div>
                    <q-separator color="primary" />
                    <q-item clickable v-ripple :active="link === 'inbox'" @click="link = 'inbox'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/user/catalogo">
                        <q-item-section avatar>
                            <q-icon name="inbox" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Catalogo
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'misautos'" @click="link = 'misautos'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/user/mis-autos">
                        <q-item-section avatar>
                            <q-icon name="mdi-car" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Mis Autos
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'solicitudes'" @click="link = 'solicitudes'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/user/mis-solicitudes">
                        <q-item-section avatar>
                            <q-icon name="mdi-clipboard-text" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Mis Solicitudes
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'send'" @click="link = 'send'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/user/mis-cotizaciones">
                        <q-item-section avatar>
                            <q-icon name="mdi-calculator-variant" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Mis Cotizaciones
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'cuentas'" @click="link = 'cuentas'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/user/cuentasporpagar">
                        <q-item-section avatar>
                            <q-icon name="mdi-account-cash" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Cuentas por Pagar
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'contratos'" @click="link = 'contratos'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/user/mis-contratos">
                        <q-item-section avatar>
                            <q-icon name="mdi-file-document-edit" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Mis Contratos
                        </q-item-section>
                    </q-item>

                    <!-- <q-item clickable v-ripple :active="link === 'star'" @click="link = 'star'"
                        active-class="my-menu-link" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="star" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Mis autos
                        </q-item-section>
                    </q-item> -->

                    <!-- <q-item clickable v-ripple :active="link === 'drafts'" @click="link = 'drafts'"
                        active-class="my-menu-link" class="rounded-borders">
                        <q-item-section avatar>
                            <q-icon name="drafts" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Historial
                        </q-item-section>
                    </q-item> -->
                </q-list>
            </q-scroll-area>
        </q-drawer>

        <q-header class="rounded-borders q-ma-md " elevated height-hint="64">
            <q-toolbar class="bg-white shadow-1 rounded-borders  q-py-md">
                <q-btn flat round dense>
                    <q-icon class="text-grey" name="mdi-menu" @click="miniState = !miniState" />
                </q-btn>
                <q-input dense borderless v-model="text" label="Buscar" input-class="text-left" class="q-ml-md">
                    <template v-slot:prepend>
                        <q-icon v-if="text === ''" class="text-grey" name="mdi-magnify" />
                        <q-icon v-else name="clear" class="cursor-pointer" @click="text = ''" />
                    </template>
                </q-input>
                <q-space />
                <q-btn flat round dense class="q-mr-sm">
                    <q-icon class="text-grey" name="mdi-moon-waning-crescent" />
                </q-btn>
                <q-btn flat round dense class="q-mr-sm">
                    <q-icon class="text-grey" name="mdi-white-balance-sunny" />
                </q-btn>
                <q-btn flat round dense class="q-mr-sm">
                    <q-icon class="text-grey" name="mdi-folder" @click="dialogDocumentos = true" />
                </q-btn>
                <q-btn flat round dense class="q-mr-sm">
                    <q-icon class="text-grey" name="mdi-bell" />
                    <q-badge color="red" floating>{{ contadorNotificaciones }}</q-badge>
                    <q-menu>
                        <q-list bordered class="rounded-borders" style="max-width: 350px">
                            <q-item-label header class="row">
                                <div class="q-mt-md">
                                    Notificaciones
                                </div>
                                <q-space />
                                <q-btn flat round color="primary" icon="mdi-refresh"
                                    @click="GetNotificacionesUsuario()" />
                            </q-item-label>

                            <q-item clickable v-ripple v-for="noti in notificacionesStore" :key="noti._id">
                                <q-item-section avatar>
                                    <q-avatar v-if="noti.tipo == 'Error'" color="red" text-color="white"
                                        icon="mdi-alert" />
                                </q-item-section>

                                <q-item-section>
                                    <q-item-label lines="1">{{ noti.titulo }}</q-item-label>
                                    <q-item-label caption lines="3">
                                        <span class="text-weight-bold">{{ noti.subtitulo }}</span>
                                        {{ noti.mensaje }}
                                    </q-item-label>
                                </q-item-section>

                                <q-item-section side top>
                                    {{ noti.fecha }}
                                </q-item-section>

                            </q-item>
                            <q-separator inset="item" />

                        </q-list>
                    </q-menu>
                </q-btn>
                <q-avatar class="cursor-pointer">
                    <img :src="usuarioStore.fotoPerfilBase64">
                    <q-badge color="green" rounded floating />
                    <q-menu content-class="bg-primary text-white" auto-close>
                        <q-list style="min-width: 120px">
                            <q-item clickable to="/dashboard/user/mi-perfil">
                                <q-item-section avatar>
                                    <q-icon name="settings" color="white" />
                                </q-item-section>
                                <q-item-section>
                                    Configuración
                                </q-item-section>
                            </q-item>
                            <q-item clickable @click="logout()">
                                <q-item-section avatar>
                                    <q-icon name="mdi-logout" color="white" />
                                </q-item-section>
                                <q-item-section>
                                    Cerrar Sesión
                                </q-item-section>
                            </q-item>

                        </q-list>
                    </q-menu>
                </q-avatar>
            </q-toolbar>
        </q-header>

        <q-page-container>
            <router-view />
        </q-page-container>
    </q-layout>
</template>

<script>
import axios from "axios";

import { mapActions } from 'vuex'
import Documentos from '../Usuario/MiPerfil/Biblioteca.vue';
import DatosFiscales from '../Usuario/MiPerfil/InformacionFiscal.vue';

export default {
    name: "Dashboard",
    components: {
        Documentos,
        DatosFiscales
    },
    data() {
        return {
            leftDrawerOpen: true,
            search: "",
            menu: {
                dashboard: true,
            },

            drawer: false,
            miniState: false,
            text: '',
            link: '',
            dialogDocumentos: false,
            dialogDatosFiscales: false

        };
    },
    created() {
        // this.GetDocumentosUsuario()
        this.GetNotificacionesUsuario()
        this.obtenerPerfil()
    },
    computed: {
        usuarioStore() {
            return this.$store.state.auth.usuario;
        },
        notificacionesStore() {
            return this.$store.state.auth.notificacionesStore;
        },
        contadorNotificaciones() {
            return this.$store.state.auth.notificacionesStore.length;
        }
    },
    methods: {
        ...mapActions('auth', ['cerrarSesion']),
        logout() {
            this.cerrarSesion()
            this.$router.push({ name: 'login' })
        },

        selectMenu(name) {
            // lógica para cambiar de menú, aquí solo mostramos un ejemplo
            console.log("Seleccionaste:", name);
        },
        toggleDarkMode() {
            this.$q.dark.toggle();
        },
        drawerClick(e) {
        },
        async obtenerPerfil() {
            try {
                const res = await axios.get('Configuracion/GetDatosFiscalesPorId/' + this.usuarioStore._id)

                if (res.data) {
                    this.dialogDatosFiscales = false
                    this.datos = res.data
                } else {
                    this.dialogDatosFiscales = true
                }

                console.log('res.data', res.data)
            } catch (err) {
            }
        },
        // async GetDocumentosUsuario() {
        //     try {
        //         let respuesa = await axios.get('Documentos/GetDocumentosUsuario/' + this.usuarioStore._id)
        //         console.log(respuesa)
        //         this.$store.state.auth.documentosStore = respuesa.data
        //         this.dialogDocumentos = true

        //     } catch (error) {
        //         console.log(error)
        //     }
        // },

        async GetNotificacionesUsuario() {
            try {
                let respuesa = await axios.get('Login/GetNotificaciones/' + this.usuarioStore._id)
                console.log(respuesa)
                this.$store.state.auth.notificacionesStore = respuesa.data

            } catch (error) {
                console.log(error)
            }
        }

    },
};
</script>

<style>
.q-page-container {
    height: calc(100vh - 0px);
    /* 64px = altura del header, ajusta si tu header es más grande */
    overflow: hidden;
    padding: 0;
}

.q-page {
    height: 100%;
    overflow: hidden;
}

.scrollable-card-container {
    height: 100%;
    overflow-y: auto;
}

.bg-purple {
    background: linear-gradient(45deg, #6a52fa, #a17ff9);
}

.class-menu-icono {
    color: #697A8D;
}

.my-menu-link {
    color: white;
    background: #0094CA;
}

.my-menu-link i {
    color: white;
}

.q-page-container {
    overflow: hidden;
}

.mini-logo-container {
    padding: 8px !important;
    /* Ajusta el padding para el modo mini */
}

/* Puedes ajustar el color de fondo si lo deseas */
.q-drawer.bg-white {
    background-color: #ffffff;
}
</style>

<!-- <template>
    <div>
        <h1>Panel de Administrador</h1>
        <p>Bienvenido, administrador.</p>
    </div>
</template>

<script>
export default {
    name: 'DashboardAdmin'
}
</script> -->